import React, { useState } from "react";

const Overview = ({ data }) => {
    const [expanded, setExpanded] = useState(false);
    const [videoPlayed, setVideoPlayed] = useState(false);

    if (!data) return null;

    const handleReadMore = () => {
        setExpanded(!expanded);
    };

    const handlePlayVideo = () => {
        setVideoPlayed(true);
    };

    // Extract YouTube video ID from URL
    const getYouTubeId = (url) => {
        if (!url) return null;
        const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([^&?]+)/);
        return match ? match[1] : null;
    };

    const videoId = getYouTubeId(data.youtube_link);
    const thumbnailUrl = videoId ? `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg` : null;

    return (
        <section className="overview-section">
            <div className="container">
                <div className="sec-title text-center">
                    <h2>{data.heading || "Overview"}</h2>
                </div>

               <div className="row mb-3 mb-md-5 d-flex justify-content-center align-items-center">
                    

    <div 
        className={`
            col-md-6 col-12
            order-2            
            ${data.video_position === 'right' ? '' : 'order-md-2'}  /* desktop swap only */
        `}
    >
        <div className="content-container">
            <div 
                className="visible-content"
                dangerouslySetInnerHTML={{ __html: data.description }} 
            />
            
            {expanded && data.read_more_content && (
                <div className="expandable-content">
                    <div dangerouslySetInnerHTML={{ __html: data.read_more_content }} />
                </div>
            )}

            {data.read_more_content && (
                <button className="readmoreall mt-3 mb-3 mb-md-0" onClick={handleReadMore}>
                    {expanded ? "Read Less" : data.read_more_text || "Read More"}
                </button>
            )}
        </div>
    </div>

    {/* Right Column - Video */}
    <div 
        className={`
            col-md-6 col-12
            order-1            
            ${data.video_position === 'right' ? '' : 'order-md-1'}  /* desktop swap only */
        `}
    >
        <div className="custom-video-player mb-3 mb-md-0">
            {!videoPlayed ? (
                <div
                    className="video-poster"
                    style={{
                        backgroundImage: `url('${thumbnailUrl || "https://i.ytimg.com/vi_webp/RuFedzEQHGE/maxresdefault.webp"}')`,
                    }}
                >
                    <div className="thumbnail-overlay" />
                    <button className="play-btn" onClick={handlePlayVideo} aria-label="Play video">
                        <svg width="80" height="80" viewBox="0 0 80 80" className="play-icon">
                            <circle cx="40" cy="40" r="38" fill="#f00" className="play-button-bg" />
                            <path d="M32 25L55 40L32 55Z" fill="#fff" className="play-triangle" />
                        </svg>
                    </button>
                </div>
            ) : (
                <div className="video-container">
                    <iframe
                        className="youtube-iframe"
                        src={`https://www.youtube.com/embed/${videoId || 'RuFedzEQHGE'}?autoplay=1&rel=0`}
                        allowFullScreen
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        title={data.heading || "Internship Video"}
                    />
                </div>
            )}
        </div>
    </div>
</div>

            </div>
        </section>
    );
};

export default Overview;